import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Kanbantemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Kanban",
        content: [
        "Overview of Kanban and its uses",
        "Basic concepts and terminology",
        "Kanban principles and practices"
        ]
        },
        {
        title: "Kanban Board Design",
        content: [
        "Kanban board setup and design",
        "Types of Kanban boards",
        "Visual management and information radiators"
        ]
        },
        {
        title: "Managing Flow",
        content: [
        "Understanding and measuring flow",
        "Identifying bottlenecks and limiting work in progress",
        "Implementing pull systems"
        ]
        },
        {
        title: "Kanban in Practice",
        content: [
        "Implementing Kanban in different contexts (e.g. software development, manufacturing)",
        "Common challenges and how to overcome them",
        "Case studies of successful Kanban implementations"
        ]
        },
        {
        title: "Continuous Improvement with Kanban",
        content: [
        "Kaizen and continuous improvement",
        "Using metrics to drive improvement",
        "Implementing feedback loops"
        ]
        },
        {
        title: "Kanban and Agile",
        content: [
        "Kanban vs. Scrum",
        "Using Kanban in Agile software development",
        "Agile and Lean principles in Kanban"
        ]
        },
        {
        title: "Kanban and Lean",
        content: [
        "The history of Lean manufacturing",
        "Applying Lean principles to Kanban",
        "Value stream mapping with Kanban"
        ]
        },
        {
        title: "Kanban Tools and Software",
        content: [
        "Introduction to Kanban software (e.g. Trello, Jira)",
        "Comparing Kanban software options",
        "Using Kanban software for team collaboration"
        ]
        },
        {
        title: "Kanban Metrics and Analytics",
        content: [
        "Common Kanban metrics",
        "Using analytics to track performance",
        "Data visualization and reporting with Kanban"
        ]
        },
        {
        title: "Scaling Kanban",
        content: [
        "Scaling Kanban for larger teams and organizations",
        "Managing dependencies and portfolios with Kanban",
        "Best practices for scaling Kanban"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is Kanban Training?',
        answer:
          'Kanban Training is a specialized program designed to teach individuals the principles and practices of Kanban, an agile methodology for managing work processes and improving efficiency',
      },
      {
        question: 'Why is Kanban Training important?',
        answer:
          'Kanban Training is essential for organizations looking to streamline their workflows, increase productivity, and achieve continuous improvement through the implementation of Kanban principles',
      },
      {
        question: 'Who can benefit from Kanban Training at the best training centre?',
        answer:
          'Kanban Training at the best training centre is suitable for project managers, team leaders, software developers, and anyone involved in managing projects or workflows'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'A person with Kanban skills can pursue a variety of career opportunities such as Agile Coach, Scrum Master, Product Owner, Project Manager, and Lean Six Sigma Practitioner.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Kanban at the Best Training Centre. Our comprehensive Kanban training program welcomes learners from diverse backgrounds, regardless of prior experience. Whether you're a project manager, team leader, or aspiring agile practitioner, our courses cater to individuals at every proficiency level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Kanban principles, practices, and techniques. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in the dynamic world of Kanban. Join us and unlock your Kanban mastery with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
 
     return(
      <>
         
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Kanban is a management method that facilitates team collaboration and increased efficiency.It is a powerful way for Agile teams and organizations to visualize work, identify and eliminate bottlenecks, and achieve measurable operational improvements in throughput and quality."/> */}
            
          <NewMainsec rating='4.2' students={"523"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="Kanban is a management method that facilitates team collaboration and increased efficiency.It is a powerful way for Agile teams and organizations to visualize work, identify and eliminate bottlenecks, and achieve measurable operational improvements in throughput and quality."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Our Kanban Training program in ${this.props.location} is designed to provide you with a comprehensive understanding of the Kanban method, an Agile framework for managing and improving workflow. In this training program, you will learn about the principles of Kanban, how to design and implement a Kanban board, how to manage flow and limit work in progress, and how to continuously improve your processes using Kanban metrics.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Kanban course covers a wide range of topics, including visualizing work, limiting work in progress, managing flow, making process policies explicit, implementing feedback loops, and improving collaboratively and evolving experimentally. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Kanban. By the end of the course, you will be able to implement Kanban practices in your own projects."}/>
           </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou="Scrum Master" coupath="scrum-master" cou1='Dynamic365' coupath1='dynamic365' cou2='Pega' coupath2='pega' cou10='PowerApps' coupath10='powerapps' cou4='Jira' coupath4='jira-admin' 
          cou5='Endpoint Manager' coupath5='endpoint-manager' cou8='ITSM' coupath8='itsm' cou7='ServiceNow' coupath7='servicenow' cou6='Okta' coupath6='okta' cou9='Mulesoft' coupath9='mulesoft'  cou3='SAP' coupath3='sap'/>
      </>
    );
  }
}
